<template>
  <div :class="['container','o-combobox',icon?'selectdivIcon':'selectdiv']  ">
    <span class="inputName">{{ label }}</span>
    <div v-if="icon" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <span class="icon" :class="[icon]"
                  @click="enterClicked" :style="{color: iconColor, fontSize: iconSize}"></span>
    </div>
    <label>
      <input spellcheck="false" :class="[{iconPadding: icon},'o-combobox__input']"
             :ref="'combobox-'+mediumIndex+'-'+insertionOrderIndex" v-click-outside="closeDropdown"
             @input="filter" v-model="selected" :disabled="disabled" :required="this.isRequired"
             type="search" v-on:click="showDropdown"
             v-on:keyup.enter.prevent="enterClicked(selectedIndex)" v-on:keydown.down.prevent="selectNext()"
             v-on:keydown.up.prevent="selectPrev()"/>
      <ul ref="siteWrapper" :class="['o-date-list',deleteSelected?'relative':'absolute']"
          v-show="showAutocompleteDropdown">
        <li :ref="item.name+'-'+mediumIndex+'-'+insertionOrderIndex" class="o-date-list__item"
            v-for="(item,index) in filteredItems" :key="item.name + '-' + index"
            v-on:click.prevent="select(index)"
            v-bind:class="{'o-date-list__item--selected': index === selectedIndex}">
          {{ item.name }}
        </li>
      </ul>
    </label>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  data: function () {
    return {
      item: "",
      showAutocompleteDropdown: false,
      selectedIndex: 0,
      selected: '',
      filteredItems: [],

    }
  },
  props: {
    placeholder: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    deleteSelected: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false,
      default: null
    },
    initial: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    selectOnClick: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array
    },
    insertionOrderIndex: {
      type: Number
    },
    mediumIndex: {
      type: Number
    },
    icon: String,
    iconColor: String,
    iconBorder: Boolean,
    iconSize: String
  },
  mounted() {
    this.filteredItems = this.items;
    if (this.initial && this.initial !== '') {
      this.select(this.findInItems(this.initial), true);
    }
  },
  computed: {
    isRequired() {
      return this.required && this.selected === '';
    }
  },
  methods: {
    select: function (index, init = false) {
      this.showAutocompleteDropdown = false;
      event.stopPropagation();
      this.selected = this.filteredItems[index].name
      this.$refs['combobox-' + this.mediumIndex + '-' + this.insertionOrderIndex].focus();
      if ((!this.deleteSelected && !init) || this.selectOnClick) {
        this.$emit('enter', this.filteredItems[index]);
      }
    },
    selectNext: function () {
      if (this.showAutocompleteDropdown) {
        if (this.selectedIndex < this.filteredItems.length - 1) {
          this.selectedIndex++;
          this.$refs[this.filteredItems[this.selectedIndex].name + '-' + this.mediumIndex + '-' + this.insertionOrderIndex][0].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          })
        } else {
          this.selectedIndex = 0;
        }
      } else {
        this.showAutocompleteDropdown = true;
      }

    },
    selectPrev: function () {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.$refs[this.filteredItems[this.selectedIndex].name + '-' + this.mediumIndex + '-' + this.insertionOrderIndex][0].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        })
      } else {
        this.selectedIndex = this.filteredItems.length - 1;
      }
    },
    showDropdown() {
      this.showAutocompleteDropdown = true
    },
    closeDropdown() {
      this.showAutocompleteDropdown = false
    },
    enterClicked(selectedIndex) {
      if (this.showAutocompleteDropdown) {
        this.select(selectedIndex);
      } else {
        let index = !this.editable ? this.findExactInItems(this.selected) : this.findInItems(this.selected);
        if ((index !== -1 && this.deleteSelected) || !this.deleteSelected) {
          if (index !== -1) {
            if (!this.editable && this.items[index].name !== this.selected.trim()) {
              this.$noty.error('Kein passender Wert gefunden');
            } else {
              const original = this.items[index];
              const payload = original.name !== this.selected.trim()
                  ? {...original, edited: this.selected}
                  : {...original};

              this.$emit('enter', payload);
              //this.showDropdown();
              if (this.deleteSelected) {
                this.selected = '';
              }
            }


          } else {
            if (this.editable) {
              this.$emit('enter', {edited: this.selected});
            } else {
              this.$noty.error('Kein passender Wert gefunden');
            }

            //this.showDropdown();
          }
          this.filteredItems = this.items;
        } else {
          this.$noty.error('Ungültige Eingabe');
        }

      }
    },
    filter: function () {
      if (this.selected.trim() === '') {
        this.filteredItems = this.items;
      }
      let ret = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].name.toLowerCase().indexOf(this.selected.toLowerCase()) !== -1) {
          ret.push(this.items[i]);
        }
      }
      if (this.filteredItems.length === 0) {
        this.showAutocompleteDropdown = false;
      } else {
        this.showAutocompleteDropdown = true;
      }
      this.filteredItems = ret;
    },
    findInItems(name) {
      for (let i = 0; i < this.items.length; i++) {
        if (name.indexOf(this.items[i].name) !== -1) {
          return i;
        }
      }
      return -1;
    },
    findExactInItems(name) {
      for (let i = 0; i < this.items.length; i++) {
        if (name === this.items[i].name) {
          return i;
        }
      }
      return -1;
    }
  }
}
</script>

<style lang="scss" scoped>


.o-date-list {

  background: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  z-index: 1000;
  margin-top: 0;
  max-height: 15em;

}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.o-date-list__item {
  margin: 0;
  list-style-type: none;
  padding: 0.5rem;
  font-size: 14px;

  display: block;

  text-align: center;
  cursor: pointer;

}

.o-date-list__item:hover {
  opacity: 0.5;
}

.o-date-list__item--selected {
  background: rgba(0, 0, 0, 0.1);
}

.container {
  position: relative;
}

.inputName {
  position: absolute;
  left: 10px;
  top: 5px;
  font-size: 11px;
  color: #777;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

select {
  padding: 1.2em 0.5em 0.5em 0.5em;
  font-size: 15px;
  width: 100%;
  border-color: $grey;
}

select:disabled {
  background: transparent;
  border-color: transparent;
  border-bottom: 1px solid #ccc;
  color: black;
}

select::-ms-expand {
  display: none;
}

.selectdiv:after {
  content: '<>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  /*Adjust for position however you want*/

  top: 13px;
  padding: 0 0 2px;

  position: absolute;
  pointer-events: none;
}

.selectdivIcon:after {
  content: '<>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  /*Adjust for position however you want*/

  top: 13px;
  padding: 0 3rem 2px;

  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

:required {
  border: 2px solid $pink !important;
}

.inputContainer {
  position: relative;
}

input {
  padding: 1.1em 1.8em 0.5em 0.5em;
  width: 100%;
  font-size: 15px;
  border: 1px solid $grey !important;
  -webkit-appearance: none;
}

input:disabled {
  background: transparent;
  border-color: transparent;
  border-bottom: 1px solid #ccc;
  color: black;
}

input:focus ~ .label, input:disabled ~ .label,
input:disabled:not(:focus):valid ~ .label, input:not(:focus):valid ~ .label {
  top: 6px;
  bottom: 10px;
  left: 9px;
  font-size: 11px;
  opacity: 1;
}

.iconPadding {
  padding-right: 3em;
}

.label {
  position: absolute;
  left: 10px;
  top: 16px;
  font-size: 1em;
  color: $darkGrey;
  pointer-events: none;
  transition: 0.2s ease all;
  opacity: 0.5;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.leftBorder {
  border-left: 1px solid $grey;
}

.iconContainer {
  position: absolute;
  top: 0;
  right: 0;
  border-left: 1px solid $grey;
  width: 47px;
  height: 100%;
}

.icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  right: 0;
  font-size: 2.1em;
}

.icon:hover {
  color: $pink;
}

.icon:before {
  display: flex;
}

.pointer {
  cursor: pointer;
}

.iconPadding {
  padding-right: 3em;
}

.iconContainer {
  position: absolute;
  top: 0;
  right: 0;
  border-left: 1px solid $grey;
  width: 47px;
  height: 100%;
}

.icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  right: 0;
  font-size: 2.1em;
}

.icon:hover {
  color: $pink;
}

.icon:before {
  display: flex;
}

</style>